import { AppState } from '../core/constants.js';

const stateLabelMap = {
  [AppState.CLOSED]: '合拢态',
  [AppState.DISPERSED]: '散开态',
  [AppState.PHOTO_FOCUS]: '照片放大态'
};

export class HudController {
  constructor() {
    this.seasonLabelEl = document.querySelector('[data-role="season-label"]');
    this.stateLabelEl = document.querySelector('[data-role="state-label"]');
    this.gestureStatusEl = document.querySelector('[data-role="gesture-status"]');
    this.photoCountEl = document.querySelector('[data-role="photo-count"]');
    this.perfLabelEl = document.querySelector('[data-role="perf-label"]');
    this.toastEl = document.querySelector('[data-role="toast"]');
  }

  setSeasonLabel(label) {
    this.seasonLabelEl.textContent = label;
  }

  setState(state) {
    this.stateLabelEl.textContent = stateLabelMap[state] || state;
  }

  setGestureStatus(message, isError = false) {
    this.gestureStatusEl.textContent = message;
    this.gestureStatusEl.classList.toggle('is-error', isError);
  }

  setPhotoCount(count) {
    this.photoCountEl.textContent = `${count} 张`;
  }

  setPerformance({ averageFps, onePercentLow }) {
    this.perfLabelEl.textContent = `平均 ${averageFps.toFixed(1)} FPS / 1% Low ${onePercentLow.toFixed(1)}`;
  }

  toast(message, level = 'info') {
    this.toastEl.textContent = message;
    this.toastEl.dataset.level = level;
    this.toastEl.classList.add('visible');
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(() => {
      this.toastEl.classList.remove('visible');
    }, 2800);
  }
}
